import React, { FC, ReactElement, useContext } from 'react'
import { ReactState } from '../../../../../React/Common/Types/Types'
import { Modal } from '../../../Molecules/Modal/Modal'
import CLanguageHandler from '../../../../../NonReact/Languages/LanguageHandler'
import LanguageContext from '../../../../../React/Common/Contexts/LanguageContext'
import { isVarNotEmpty } from '../../../../../NonReact/utils/GlobalFunctions'
import { ClientConfigurationTabs } from './Tabs/ClientConfigurationTabs'
import { ClientConfigurationModalLanguage, GenericModal } from '../../../../../../i18n'
import { SelectedEntry } from './Types/Types'
import { AdminFilterSingleValues } from '../../../Molecules/AdminFilters/AdminFilters'

type Props = {
    openState: ReactState<boolean>
    selectedEntry?: SelectedEntry
    isViewOnly?: boolean
    closeModal: (refresh?: boolean) => void
    filters: Nullable<AdminFilterSingleValues>
}

export const ClientConfigurationModal: FC<Props> = ({
    openState: [isOpen, setIsOpen],
    selectedEntry,
    isViewOnly,
    closeModal,
    filters
}: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle(ClientConfigurationModalLanguage.NAME)
    language.loadBundle(GenericModal.NAME)

    return (
        <Modal
            className='client-configuration-modal'
            inlineExitPromptSettings={{
                message: language.get(GenericModal.GenericModal_PromptMessage),
                confirmButtonText: language.get(GenericModal.GenericModal_PromptConfirm),
                cancelButtonText: language.get(GenericModal.GenericModal_PromptCancel),
                isRouterMode: true
            }}
            isOpen={isOpen}
            closeOnBackdropClick
            onClose={(): void => setIsOpen(false)}
        >
            <div className='client-configuration-modal-container'>
                <div className='modal-title-report-config'>
                    {isVarNotEmpty(selectedEntry)
                        ? language.get(ClientConfigurationModalLanguage.ClientConfigurationModal_ChangeTitle)
                        : language.get(ClientConfigurationModalLanguage.ClientConfigurationModal_AddTitle)}
                </div>
                <ClientConfigurationTabs
                    isViewOnly={isViewOnly}
                    selectedEntry={selectedEntry}
                    closeModal={closeModal}
                    filters={filters}
                />
            </div>
        </Modal>
    )
}
